import { Length, ModelBase, NonNegative, Property, Required } from '@skylab-shared/core';
import { DiscountKind } from '@skylab-shared/dataModel';
import { OrderProductKind } from './common/order-product-kind';

export class OrderItemModel extends ModelBase {
	@Property()
	public readonly id?: number;

	@Property()
	public ordinalNumber: number;

	@Property()
	@Length({ max: 255 }, 'data-model.document-item.validation.name.length')
	@Required('data-model.document-item.validation.name.not-empty')
	public name: string;

	@Property()
	public sku: string;

	@Property()
	public unitExternalId: string;

	@Property()
	@NonNegative('data-model.orders.items.validation.quantity.cannot-be-less-than-zero')
	public quantity: number;

	@Property()
	public vatRateId: string;

	@Property()
	public unitWidth: number;

	@Property()
	public unitHeight: number;

	@Property()
	public unitLength: number;

	@Property()
	public unitWeight: number;

	@Property()
	public kind: OrderProductKind;

	@Property()
	public commission: number;

	@Property()
	public image: string;

	@Property()
	public value_grossAfterDiscount: number;

	@Property()
	public value_grossBeforeDiscount: number;

	@Property()
	public value_netAfterDiscount: number;

	@Property()
	public value_netBeforeDiscount: number;

	@Property()
	public value_vatAfterDiscount: number;

	@Property()
	public value_vatBeforeDiscount: number;

	@Property()
	public price_grossAfterDiscount: number;

	@Property()
	@NonNegative('data-model.orders.items.validation.price.cannot-be-less-than-zero')
	public price_grossBeforeDiscount: number;

	@Property()
	public price_netAfterDiscount: number;

	@Property()
	public price_netBeforeDiscount: number;

	@Property({nullable: true})
	public offerId: string;

	@Property({nullable: true})
	public offerUrl: string;

	@Property({nullable: true})
	public offerName: string;

	//#region CALCULATIONS PURPOSE ONLY
	@Property()
	public discountValue: number;

	@Property()
	public discountKind: DiscountKind;
	//#endregion CALCULATIONS PURPOSE ONLY

	//#region SKYLAB PRODUCT INFO
	@Property()
	public symbol: string;

	@Property(String, {nullable: true})
	public productId: string | null;

    @Property({nullable: true})
    public inventoryControl?: boolean;
	//#endregion
}
